// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const uscc: CountryValidator<"CN"> = createValidator(
  "cn.uscc",
  37,
);

export default uscc;
export const compact = uscc.compact;
export const format = uscc.format;
export const validate = uscc.validate;
export const generate = (): string =>
  uscc.generate?.() ??
  (() => {
    throw new Error(
      "Validator cn.uscc cannot generate values",
    );
  })();
